module.exports = __webpack_public_path__ + "videos/hero_cn.6ffaf37.mp4";